import { getAccount, getAssociatedTokenAddress } from '@solana/spl-token'
import { PublicKey } from '@solana/web3.js'

import { ORDER_BOOK_PROGRAM_ID } from '@src/chains/solana/anchor/setup'
import { SOLANA_CONNECTION } from '@src/chains/solana/config'
import { findProgramAddress } from '@src/chains/solana/utils'
import { walletLogger } from '@src/utils/logger'

export const getSolanaAllowance = async (address: string, owner: string, spender: string): Promise<bigint> => {
    try {
        walletLogger.debug('Getting associated token account for:', {
            address,
            owner,
        })
        const tokenAccount = await getAssociatedTokenAddress(new PublicKey(address), new PublicKey(owner))

        walletLogger.debug('Determining delegate to check')
        const delegateToCheck =
            spender === ORDER_BOOK_PROGRAM_ID.toString()
                ? findProgramAddress('TristeroOapp', ORDER_BOOK_PROGRAM_ID).publicKey
                : new PublicKey(spender)

        walletLogger.debug('Getting token account info')
        const tokenAccountInfo = await getAccount(SOLANA_CONNECTION, tokenAccount)

        walletLogger.debug('Checking delegation:', {
            tokenAccount: tokenAccount.toString(),
            currentDelegate: tokenAccountInfo.delegate?.toString(),
            expectedDelegate: delegateToCheck.toString(),
            delegatedAmount: tokenAccountInfo.delegatedAmount.toString(),
            isOrderBook: spender === ORDER_BOOK_PROGRAM_ID.toString(),
        })

        if (tokenAccountInfo.delegate?.equals(delegateToCheck)) {
            walletLogger.debug('Delegate matches, returning amount:', {
                amount: tokenAccountInfo.delegatedAmount.toString(),
            })
            return BigInt(tokenAccountInfo.delegatedAmount.toString())
        }
        walletLogger.debug('No matching delegate, returning 0')
        return BigInt(0)
    } catch (error) {
        walletLogger.error('Error checking Solana delegate:', { error })
        return BigInt(0)
    }
}
